import Bluebird from 'bluebird'
import { XHRError } from './errors.js'

const Promise = Bluebird

Promise.config({
    warnings: true,
    cancellation: true,
    longStackTraces: true,
})

/**
 * Override original Promise.resolve method to correctly resolving of jQuery XHR object
 * @inheritDoc
 */
Promise.resolve = (function (origResolve) {
    return (
        /**
         * @param {*} value
         * @returns {Promise}
         * todo throw different errors for each status
         */
        function (value) {
            if (value && typeof value.abort === 'function') {
                return new Promise((resolve, reject, onCancel) => {
                    // abort request on cancellation
                    onCancel(() => value.abort())
                    // fix jquery callback
                    // todo reject не всплывает по цепочке
                    value.then(
                        resolve,
                        jqXHR => reject(
                            new XHRError(
                                [
                                    jqXHR.status,
                                    jqXHR.statusText,
                                ].join(' '),
                                jqXHR.responseText,
                            ),
                        ),
                    )
                })
            }

            return origResolve(value)
        })
}(Promise.resolve))

global.Promise = Promise

export default Promise
